import { defineComponent as r, computed as n, openBlock as o, createElementBlock as i, normalizeStyle as d, normalizeClass as c, unref as m, renderSlot as p } from "vue";
import { useNamespace as u } from "./index559.js";
var w = /* @__PURE__ */ r({
  name: "ElAside",
  __name: "aside",
  props: {
    width: { type: [String, null], required: !1, default: null }
  },
  setup(s) {
    const e = s, t = u("aside"), l = n(
      () => e.width ? t.cssVarBlock({ width: e.width }) : {}
    );
    return (a, f) => (o(), i(
      "aside",
      {
        class: c(m(t).b()),
        style: d(l.value)
      },
      [
        p(a.$slots, "default")
      ],
      6
      /* CLASS, STYLE */
    ));
  }
});
export {
  w as default
};
